import {
  Box,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

const InvoiceDinnerByLocation = ({ invoiceDetails, invoiceSummaryData }) => {
  // console.log("summary_table", invoiceDetailsByLocation);
  const renderTableCell = (item, type, isLastRow) => {
    return (
      <TableCell
        sx={{
          // borderBottom: isLastRow ? "none" : undefined,
          border: "1px solid #ccc",
          color: "black",
          textTransform: "capitalize",
        }}
      >
        {(() => {
          const matchedMeals = invoiceSummaryData?.invoiceSummary?.filter(
            (meal) =>
              // meal.mealDate === item.mealDate &&
              meal.days_name?.trim() === item.days_name?.trim()
          );
          return matchedMeals.length > 0
            ? matchedMeals
                .map((m) => renderMealDataAsPerDay(type, m))
                .join(" & ")
            : renderMealDataAsPerDay(type, item);
        })()}
      </TableCell>
    );
  };
  const renderMealDataAsPerDay = (type, result) => {
    switch (type) {
      case "meal_type":
        return result.diet_name;
      case "plate_price":
        return `₹ ${result.vendor_per_plate_price}`;
      case "min_gur":
        return result.vendor_minimum_guarantee;
      default:
        break;
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Box sx={{ display: "flex" }}>
          <Box sx={{ flexBasis: "30%" }}>
            <Typography variant="body2" fontWeight="bold">
              Invoice Period
            </Typography>
            <Typography variant="body1">
              {invoiceDetails?.summary["Invoice Period"]}
            </Typography>
          </Box>
          <Box sx={{ flexBasis: "30%" }}>
            <Typography variant="body2" fontWeight="bold">
              Service Provider
            </Typography>
            <Typography variant="body1">
              {invoiceDetails?.summary["Service provider"]}
            </Typography>
          </Box>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Box>
          <TableContainer
            sx={{
              midth: "100%",
              marginTop: "10px",
              border: "0.5px solid #e0e0e0",
            }}
            // component={Paper}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#93CFEC33" }}>
                  {["Day", "Meal Type", "Plate Cost", "Min Gurantee"].map(
                    (item, i) => {
                      return (
                        <TableCell
                          sx={{
                            // borderBottom: isLastRow ? "none" : undefined,
                            border: "1px solid #ccc",
                            color: "black",
                            textTransform: "capitalize",
                          }}
                          key={i}
                        >
                          {item}
                        </TableCell>
                      );
                    }
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceDetails?.summary?.costAndMinGurantee?.length > 0 ? (
                  invoiceDetails?.summary?.costAndMinGurantee?.map(
                    (item, i) => {
                      const isLastRow =
                        i ===
                        invoiceDetails?.summary?.costAndMinGurantee?.length - 1;
                      return (
                        <TableRow key={i}>
                          <TableCell>{item?.days_name}</TableCell>
                          {renderTableCell(item, "meal_type", isLastRow)}
                          {renderTableCell(item, "plate_price", isLastRow)}
                          {renderTableCell(item, "min_gur", isLastRow)}
                        </TableRow>
                      );
                    }
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
    </>
  );
};

export default InvoiceDinnerByLocation;
